// extracted by mini-css-extract-plugin
module.exports = {"postImage":"StorieModal_postImage_I62lU"};